import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './EditIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const EditIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function EditIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 16" component={Icon} {...props} />
  );
});
